/* eslint-disable react/jsx-props-no-spreading */
import { FC as ReactFC, useEffect, useState } from 'react';

import BlockUi from 'react-block-ui';
import * as intl from 'react-intl-universal';
import OtpInput from 'react-otp-input';
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

import { censorEmail } from 'helpers/StringFormat';
import Status from 'shared/enums/Status';

import styles from './mfaEmailSetupModal.module.scss';
import MfaEmailSetupModalProps from './MfaEmailSetupModalProps';

const INITIAL_OTP = '';

const MfaEmailSetupModal: ReactFC<MfaEmailSetupModalProps> = (
  props: MfaEmailSetupModalProps
) => {
  const { email, isOpen, status, onToggle, onFinishSetup } = props;

  const [otp, setOtp] = useState<string>(INITIAL_OTP);

  useEffect(() => {
    if (isOpen) {
      setOtp(INITIAL_OTP);
    }
  }, [isOpen]);

  const onClosed = (): void => {
    setOtp(INITIAL_OTP);
  };

  const handleFinishSetup = (): void => {
    onFinishSetup(otp);
  };

  const displayEmail = censorEmail(email);

  return (
    <Modal
      size="md"
      isOpen={isOpen}
      toggle={onToggle}
      backdrop="static"
      centered
      autoFocus={false}
      trapFocus
      keyboard={false}
      id="warningPromptTarget"
      onClosed={onClosed}
    >
      <BlockUi tag="div" blocking={status === Status.Loading}>
        <ModalHeader toggle={onToggle}>
          {intl.get('LBL_MFA_METHODS_EMAIL_SETUP_MODAL_TITLE')}
        </ModalHeader>
        <ModalBody>
          <Col xs="12">
            <Row className="mb-3">
              <span className="text-14-light">
                {intl.get('LBL_MFA_METHODS_EMAIL_SETUP_MODAL_DESCRIPTION')}
              </span>
            </Row>
            <Row>
              <span className="text-14-bold">{displayEmail}</span>
            </Row>
            <Row className="d-flex flex-column align-items-center mt-4 text-18-medium">
              <OtpInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                // Set inputType to tel to avoid arrow buttons
                inputType="tel"
                containerStyle={styles.otpContainer}
                inputStyle={styles.otpInput}
                shouldAutoFocus
                renderInput={(inputProps) => <input {...inputProps} />}
              />
            </Row>
          </Col>
        </ModalBody>
        <ModalFooter className="p-3">
          <Col xs="12" className="d-flex justify-content-between">
            <Button color="secondary" onClick={onToggle}>
              {intl.get('BTN_CANCEL')}
            </Button>
            <Button
              color="primary"
              disabled={otp.length !== 6}
              className={otp.length === 6 ? '' : styles.btnDisabled}
              onClick={handleFinishSetup}
            >
              {intl.get('BTN_MFA_FINISH_SETUP')}
            </Button>
          </Col>
        </ModalFooter>
      </BlockUi>
    </Modal>
  );
};

export default MfaEmailSetupModal;
